import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle size={56} className="text-gray-500 mx-auto mb-6" />
      <h1 className="font-serif-elegant text-3xl font-bold">Paiement annulé</h1>
      <p className="text-gray-400 mt-3">Aucun montant n'a été débité. Vous pouvez réessayer à tout moment.</p>
      <Link to="/profil" data-testid="payment-cancel-back" className="btn-outline-gold mt-8">Retour à mon profil</Link>
    </div>
  );
}
